import React from 'react';
import { Link } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/dblift_logo.png';
import LanguageSwitcher from './LanguageSwitcher';

const getNavigation = (t) => [
  { name: t('navigation.home'), href: '/' },
  { name: t('navigation.getting-started'), href: '/getting-started' },
  { name: t('navigation.features'), href: '/features' },
  { name: t('navigation.docs'), href: '/docs' },
  { name: t('navigation.download'), href: '/download' },
  { name: t('navigation.blog'), href: '/blog' },
  { name: t('navigation.contact'), href: '/contact' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const navigation = getNavigation(t);

  return (
    <Disclosure as="nav" className="bg-white shadow-md">
      {({ open }) => (
        <>
          <div className="container">
            <div className="relative flex items-center justify-between h-20">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-dblift-gray-dark hover:text-dblift-blue-dark hover:bg-dblift-gray-light">
                  <span className="sr-only">Ouvrir le menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <Link to="/">
                    <img
                      className="h-12 w-auto"
                      src={logo}
                      alt="DBLift Logo"
                    />
                  </Link>
                </div>
                <div className="hidden sm:ml-10 sm:flex sm:items-center sm:space-x-4">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className="font-medium text-dblift-gray-dark hover:text-dblift-orange px-3 py-2 rounded-md"
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
              <div className="hidden sm:flex items-center space-x-4">
                <LanguageSwitcher />
                <Link to="/download" className="btn btn-primary">
                  {t('hero.downloadBtn')}
                </Link>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as={Link}
                  to={item.href}
                  className="block px-3 py-2 rounded-md text-base font-medium text-dblift-gray-dark hover:text-dblift-orange hover:bg-dblift-gray-light"
                >
                  {item.name}
                </Disclosure.Button>
              ))}
              <div className="flex items-center justify-between mt-4 px-3">
                <LanguageSwitcher />
                <Link to="/download" className="btn btn-primary">
                  {t('hero.downloadBtn')}
                </Link>
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}